import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setStep, setLaterPayment } from '@redux/actions/NewOrderActions';

const mapStateToProps = ({ NewOrderReducer }) => {
  const { activeStep } = NewOrderReducer;
  return {
    $state: {
      step: activeStep,
    },
  };
};

const mapDispatchToProps = (dispatch) => ({
  $actions: bindActionCreators(
    {
      setStep,
      setLaterPayment,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
});
